;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import CountBadge from "../CountBadge"
import { MenuGlyph } from "../icons/glyphs"

/**
 * Hamburger trigger button. Extra props (onClick, aria-*, ref from a Radix
 * DropdownMenuTrigger `asChild`) are spread onto the underlying button.
 *
 * Badge offset translate(9px, -4px) relative to the icon reproduces the old
 * StyledBadge translate(1px, 4px) relative to the padded IconButton.
 */
export default function MobileMenuButton({
  badgeCount,
  ...rest
}: React.ComponentProps<"button"> & {
  badgeCount?: number
}) {
  return (
    <button
      type="button"
      aria-label="menu"
      {...rest}
      className="inline-flex cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-2 text-inherit hover:bg-[rgba(0,0,0,0.04)]"
    >
      <CountBadge
        count={badgeCount}
        offsetClassName="translate-x-[9px] translate-y-[-4px]"
      >
        <MenuGlyph size={35} />
      </CountBadge>
    </button>
  )
}
